import COLORS from '../../../../constants/colors';
export const boxSectionStyle = {
    backgroundColor: COLORS.White.T500.value,
    width: 'full',
    alignItems: 'flex-start',
    borderRadius: '.5rem',
    boxShadow: '0px 26px 34px 0px rgba(96, 97, 112, 0.06), 0px 2px 8px 0px rgba(40, 41, 61, 0.04)',
    padding: '1rem',
};
